// extracted by mini-css-extract-plugin
export default {"templates":"style_templates__H58Xh","menuItem":"style_menuItem__k5VJh","menuItemLabel":"style_menuItemLabel__Km9Pa","menuItemActions":"style_menuItemActions__KcE2y"};